module.exports = __webpack_public_path__ + "img/way_hero_image_v3.7d2c602.png";